import { FC, ReactNode, ButtonHTMLAttributes, ComponentType } from 'react';
import { cn } from '@/utils/cn';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'custom';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  as?: ComponentType<any> | string;
  to?: string;
}

export const Button: FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  as: Component = 'button',
  ...props
}) => {
  const base = 'inline-flex items-center justify-center font-semibold rounded-full select-none transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-apple-blue focus-visible:ring-offset-2';

  const variants = {
    primary:   'bg-apple-blue text-white hover:bg-apple-blue-hover active:bg-apple-blue-dark',
    secondary: 'bg-apple-dark text-white hover:bg-[#2c2c2e] active:bg-[#3a3a3c]',
    outline:   'border border-apple-mid-gray text-apple-dark hover:bg-apple-light-gray active:bg-[#E5E5EA]',
    ghost:     'text-apple-blue hover:bg-[#EBF5FF] active:bg-[#DCF0FF]',
    custom:    '',
  };

  const sizes = {
    sm: 'px-4 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-[0.9375rem]',
    lg: 'px-7 py-3.5 text-base',
  };

  return (
    <Component
      className={cn(base, variants[variant], sizes[size], className)}
      style={{ letterSpacing: '-0.01em' }}
      {...props}
    >
      {children}
    </Component>
  );
};
